import Money from "~/models/Money";

export default class Voucher {
  private readonly _discountPercentage: Number;
  private readonly _total: Money;
  private readonly _totalWithoutDiscount: Money;
  constructor({
                discountPercentage,
                total,
                totalWithoutDiscount,
              }) {
    this._discountPercentage = discountPercentage;
    this._total = total;
    this._totalWithoutDiscount = totalWithoutDiscount;
  }

  get discountPercentage(): Number {
    return this._discountPercentage;
  }

  get total(): Money {
    return this._total;
  }

  get totalWithoutDiscount(): Money {
    return this._totalWithoutDiscount;
  }
}
